import './Footer.css'
export default function Rights(){
    return(
        <footer className="the-footer">
            <div className="footer-section-left">
                <h4>Friendly Transport Ltd.</h4>
                <p>Friendlier Logistics since 2025.</p>
            </div>

            <div className="footer-section-left">
                <h4>Quick Links</h4>
                <a href="/">Home</a>
                <a href="/Clients">Clients</a>
                <a href="/About">About</a>
                <a href="/Contact">Contact</a>
                <a href="/Privacy">Privacy Policy</a>
                <a href="/Terms-and-Conditions">Customer T&Cs</a>
            </div>

            <div className="footer-section-right">
                <h4>Created by Radoslaw Zienkiewicz</h4>
                <div className="creator-links">
                <a href="https://github.com/radekzien" target='_blank' rel="noopener noreferrer">Github</a>
                <a href='https://radek-live.vercel.app/' target='_blank' rel="noopener noreferrer">Portfolio</a>
                <a href='https://www.linkedin.com/in/radoslaw-zienkiewicz/' target='_blank' rel="noopener noreferrer">LinkedIn</a>
                </div>
            </div>

            <div className="footer-bottom">
                <p>© 2026 Friendly Transport Ltd. All rights reserved.</p>
            </div>
            </footer>
    )
}